import React, { PropsWithChildren, useEffect, useRef, useState } from 'react';
import { Form, IFormOptions } from 'devextreme-react/form';
import dxForm from "devextreme/ui/form";
import LicenceDataSource, { getSmartFetchData } from '../datasource/LicenceDataSource';
import { useAuthStore } from '../hooks/useAuthStore';
import ReportFormPreparer from '../utils/ReportFormPreparer';
import { useFetching } from '../hooks/useFetching';


export interface IReportFormOptions extends IFormOptions {
    dataStore?: any;
    runDate?: any;
}


const ReportForm: React.FC<PropsWithChildren<IReportFormOptions>> = ({ dataStore, runDate, ...props }) => {
    const authStore = useAuthStore();
    const [formData, setFormData] = useState({});
    const [formDataPrepared, setFormDataPrepared] = useState(false);
//    setFormDataPrepared(false);


    let formRef = useRef(null);
    const formInstance = (): dxForm => {
        let form = formRef.current;
        if (form) {
            let instance: dxForm | null = form.instance;
            if (instance) {
                return instance;
            }
        }
        return null;
    }
    const fetchCallbackReportItem = async () => {
        setFormDataPrepared(true);
        return;
        const response = await dataStore().load();
        const item = ((response && response.data) || [])[0];
        setFormData(item);
        setFormDataPrepared(true);
    }// it's OK
    useEffect(
        () => {
            fetchCallbackReportItem();
        }
        ,
        []
    );
    const getFormData = async () => {
        const response = await dataStore().load();
        const item = ((response && response.data) || [])[0];
        return item;
    }

    const fetchArray = useFetching(getFormData);
    const fetchReportFormData = fetchArray[0] as Function;// 2 часа бился. ссылка на функцию, переданная в массиве, превращается в Promise
    

    if (!formDataPrepared)
        return (
            <div> Ждите... </div>
        )
    else
        return (
            <Form
                ref={formRef}
                formData={dataStore}
                readOnly={true}
//                items={ReportFormPreparer.formPrepare(reportObject, authStore)["items"]}
                labelMode="static"
                scrollingEnabled={true}
                className="report-form"
                {...props}
            >
                {props.children}
            </Form>


        );

}


export default React.memo(ReportForm);

